import { trackEvent } from "vendor/google/gtm/gtmEventTracker";
import { toggleDisplay } from "helpers/toggle/toggle";

export const initCollapse = function (element) {
  const selector = document.getElementsByClassName(element); //Get element

  for (let i = 0; i < selector.length; i++) {
    //Add click event to component
    selector[i].addEventListener("click", collapseElement, false);
  }
};

//Create collapse functionality
const collapseElement = function (e) {
  //Check if element clicked is not the icon to open info popup
  if (
    !e.target.closest(".open-info-popup") &&
    !e.target.closest(".open-search-info-popup")
  ) {
    const collapseType = this.parentElement.dataset.variant;
    const content = this.nextElementSibling; //Get content element

    //Get GTM event information
    const gtmCategory = this.getAttribute("data-gtm-category");
    const gtmAction = this.hasAttribute("data-gtm-action")
      ? this.getAttribute("data-gtm-action")
      : this.innerText;
    const gtmLabel = this.hasAttribute("data-gtm-label")
      ? this.getAttribute("data-gtm-label")
      : "";

    //Check if content has a height
    if (content && content.offsetHeight <= 0) {
      open(this);

      // if this is a collapse with actions, open the actions bar to
      if (collapseType === "with-actions") {
        toggleDisplay({
          isVisible: true,
          element: this.querySelector(".group-actions"),
        });
      }
      if (gtmCategory) {
        trackEvent(gtmCategory, gtmAction + " open", gtmLabel);
      }
    } else {
      //Close collapse
      close(this);

      // if this is a collapse with actions, close the actions bar to
      if (collapseType === "with-actions") {
        toggleDisplay({
          isVisible: false,
          element: this.querySelector(".group-actions"),
        });
      }
      if (gtmCategory) {
        trackEvent(gtmCategory, gtmAction + " close", gtmLabel);
      }
    }
  }
};

export const open = function (collapse) {
  const parent = collapse.parentElement;
  const content = collapse.nextElementSibling; //Get content element

  content.style.maxHeight = content.scrollHeight + "px"; //Calculate height to open collapse.

  parent.setAttribute("data-state", "open"); //Set open state
};

export const close = function (collapse) {
  const parent = collapse.parentElement;
  const content = collapse.nextElementSibling; //Get content element

  content.style.maxHeight = 0; //Remove height
  parent.setAttribute("data-state", "closed");
};
